export function Footer() {
  const links = [
    { label: 'Privacy Statement', href: 'https://www.worldfinancialgroup.com/regulatory-docs/privacy-policy' },
    { label: 'Terms & Conditions', href: 'https://www.transamerica.com/terms-of-use' },
    { label: 'Complaint Handling', href: 'https://www.mywfg.com/complaint-handling' },
    { label: 'Do Not Sell My PI', href: 'https://www.transamerica.com/do-not-sell-my-info' },
  ];

  return (
    <footer className="border-t border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 py-4 px-6 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-neutral-500 dark:text-neutral-400">
        <span>© 2026, World Financial Group, Inc.</span>
        <nav className="flex flex-wrap items-center justify-center gap-3 sm:gap-4" aria-label="Legal links">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-neutral-700 dark:hover:text-neutral-200 underline-offset-2 hover:underline transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
